const a = "Завантаження...", e = "Гаразд", t = "Скасувати", l = "Зберегти", o = "Немає даних", c = "Фільтри", n = "Пошук", s = "Редагувати", d = { loading: a, ok: e, cancel: t, save: l, noData: o, filtersButtonLabel: c, searchPlaceholder: n, editActionLabel: s };
export {
  t as cancel,
  d as default,
  s as editActionLabel,
  c as filtersButtonLabel,
  a as loading,
  o as noData,
  e as ok,
  l as save,
  n as searchPlaceholder
};
//# sourceMappingURL=common.json.js.map
